import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_paint-bid-connect/artifacts/33i9k8h9_IMG_0556.JPG";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <nav className="bg-white border-b border-gray-200 py-4">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Painting Company Hernandez" className="h-10 w-10 rounded-full object-cover" />
              <span className="font-bold text-gray-900">Painting Company Hernandez</span>
            </Link>
            <Link to="/" className="flex items-center gap-2 text-blue-600 hover:text-blue-700">
              <ArrowLeft size={20} />
              Back to Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Privacy Policy – Painting Company Hernandez</h1>
          
          <p className="text-gray-700 mb-8">
            At Painting Company H, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect information from our customers.
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-4">We may collect the following information from our customers:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Name, email, phone number, and address</li>
              <li>Payment information required to process transactions</li>
              <li>Any other information voluntarily provided to us to deliver painting services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">We use the information we collect to:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Provide and manage our painting services</li>
              <li>Process payments securely</li>
              <li>Communicate with you regarding appointments, updates, or service-related matters</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">3. Sharing Your Information</h2>
            <p className="text-gray-700 mb-4">We do not sell or share your personal information with third parties. Information is only shared when necessary to:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Provide our services</li>
              <li>Comply with the law</li>
              <li>Protect our rights</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">4. Data Security</h2>
            <p className="text-gray-700">
              We take reasonable measures to protect your personal and payment information from unauthorized access, disclosure, or misuse.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">5. Your Rights</h2>
            <p className="text-gray-700 mb-4">You have the right to:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your personal information</li>
            </ul>
            <p className="text-gray-700 mt-4">
              To exercise any of these rights, please contact us using the details below.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">6. Contact Us</h2>
            <p className="text-gray-700 mb-4">If you have any questions regarding this Privacy Policy, please contact:</p>
            <ul className="list-none text-gray-700 space-y-2 ml-4">
              <li><strong>Email:</strong> hernandezcompany9@gmail.com</li>
              <li><strong>Phone:</strong> 502-537-2762</li>
            </ul>
          </section>

          <p className="text-gray-500 text-sm mt-8 pt-8 border-t border-gray-200">
            <strong>Effective Date:</strong> March 21, 2026
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white/60 text-sm">© {new Date().getFullYear()} Painting Company Hernandez. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
